import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '../configMenu.vue';
import systemDrawerConfig from './system_drawer_config.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
export default {
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu,
    systemDrawerConfig: systemDrawerConfig
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: Array,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      typeList: [],
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      updateIndex: 0,
      showDrawer: false,
      configData: {}
    };
  },
  methods: {
    saveConfig: function saveConfig() {
      var _this = this;
      this.$refs.commonConfig.$refs.form.validate(function (valid, obj) {
        _this.value.config.menus.valid = valid;
        if (valid) {
          _this.value.config.menus = _objectSpread(_objectSpread({}, _this.value.config.menus), _this.configData.config);
          _this.showDrawer = false;
        } else {
          var _Object$values, _Object$values$, _Object$values$$;
          var errorMsg = ((_Object$values = Object.values(obj)) === null || _Object$values === void 0 ? void 0 : (_Object$values$ = _Object$values[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$ = _Object$values$[0]) === null || _Object$values$$ === void 0 ? void 0 : _Object$values$$.message) || '请完善表单信息';
          _this.$message.error(errorMsg);
        }
      });
    },
    openConfig: function openConfig() {
      this.$set(this.configData, 'config', JSON.parse(JSON.stringify(this.value.config.menus)));
      console.log(this.configData);
      this.showDrawer = true;
    },
    // 开启更多功能框：功能抽屉无数据时补默认分类（与system_drawer_config默认值一致）并标记校验通过
    changeMenusFlag: function changeMenusFlag(flag) {
      var menus = this.value.config.menus;
      if (flag && menus.value.length < 1) {
        menus.value = Array.from({
          length: 4
        }, function (_, index) {
          return _objectSpread({
            flag: true,
            imageurl: {
              0: 'https://res.youlianfuwu.com/mini_program/charge.png',
              1: 'https://res.youlianfuwu.com/mini_program/onlinecs.png',
              2: 'https://res.youlianfuwu.com/mini_program/phonecs.png',
              3: 'https://res.youlianfuwu.com/mini_program/bindcard.png'
            }[index],
            name: {
              0: '切换企业',
              1: '在线客服',
              2: '电话客服',
              3: '扫码绑卡'
            }[index]
          }, index === 0 ? {
            type: 'switch_account',
            account_sort: 1
          } : {
            type: 'other',
            link_type: '7',
            link_value: {
              1: 'online_service',
              2: 'tel_service',
              3: 'scan'
            }[index],
            goods_id: '',
            module_plate_id: ''
          });
        });
        menus.valid = true;
      }
    },
    changeType: function changeType(item) {
      this.value.config.show_style = item.id;
      // 样式2/3默认配色不同，切换时重置为对应默认值（透明度保持不变）
      if (item.id === 3) {
        this.value.config.search.bg_color = '#ffffff';
        this.value.config.menus.imageurl = 'https://ylfwresource.oss-cn-beijing.aliyuncs.com/gift-admin/workbench/more.png';
        this.value.config.position.font_color = '#ffffff';
        this.value.config.position.icon_color = '#ffffff';
        this.value.config.position.in_icon_color = '#ffffff';
      } else if (item.id === 2) {
        this.value.config.search.bg_color = '#f4f3f5';
        this.value.config.menus.imageurl = 'https://res.youlianfuwu.com/mini_program/more_new.png';
        this.value.config.position.font_color = '#c20c0c';
        this.value.config.position.icon_color = '#c20c0c';
        this.value.config.position.in_icon_color = '#c20c0c';
      }
    },
    checkFlag: function checkFlag(rule, value, callback) {
      var data = [this.value.config.position].concat(_toConsumableArray(this.value.config.value), [this.value.config.switch_account]);
      var showTabs = data.filter(function (i) {
        return i.flag;
      });
      if (showTabs.length < 1) {
        callback('至少开启一项配置');
      } else {
        callback();
      }
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this2 = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this2.pictureList = picture[1] || [];
        _this2.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (typeof this.updateIndex === 'number') {
        this.value.config.value[this.updateIndex]['imageurl'] = path;
      } else {
        this.value.config[this.updateIndex].imageurl = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      if (typeof index === 'number') {
        this.$refs.uploadBanner[index].uploadBanner();
      } else {
        this.$refs[index].uploadBanner();
      }
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
    }
  },
  created: function created() {
    var _this$tabListFlat$fin,
      _this3 = this;
    var _ref = ((_this$tabListFlat$fin = this.tabListFlat.find(function (i) {
        return i.key === _this3.value.key;
      })) === null || _this$tabListFlat$fin === void 0 ? void 0 : _this$tabListFlat$fin.config_default_value) || {},
      _ref$typeList = _ref.typeList,
      typeList = _ref$typeList === void 0 ? [] : _ref$typeList;
    this.typeList = typeList;
    var system_drawer = this.tabListFlat.find(function (i) {
      return i.key === 'system_drawer';
    });
    this.configData = JSON.parse(JSON.stringify(system_drawer));
    var _this$value$config = this.value.config,
      show_style = _this$value$config.show_style,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$po = _this$value$config.position,
      position = _this$value$config$po === void 0 ? {} : _this$value$config$po,
      _this$value$config$va = _this$value$config.value,
      value = _this$value$config$va === void 0 ? [] : _this$value$config$va,
      _this$value$config$sw = _this$value$config.switch_account,
      switch_account = _this$value$config$sw === void 0 ? {} : _this$value$config$sw,
      _this$value$config$bg = _this$value$config.bg_color,
      bg_color = _this$value$config$bg === void 0 ? '#ffffff' : _this$value$config$bg,
      _this$value$config$sp = _this$value$config.split_color,
      split_color = _this$value$config$sp === void 0 ? '#d8d8d8' : _this$value$config$sp,
      _this$value$config$se = _this$value$config.search,
      search = _this$value$config$se === void 0 ? {} : _this$value$config$se,
      _this$value$config$me = _this$value$config.menus,
      menus = _this$value$config$me === void 0 ? {} : _this$value$config$me;
    value = value.length > 0 ? value : Array.from({
      length: 3
    }, function (_, index) {
      return {
        flag: true,
        imageurl: {
          0: 'https://res.youlianfuwu.com/mini_program/shop/qrcode.png',
          1: 'https://res.youlianfuwu.com/mini_program/shop/bindcard.png',
          2: 'https://res.youlianfuwu.com/mini_program/shop/kf.png'
        }[index],
        link_type: '7',
        link_value: {
          0: 'payment_code',
          1: 'scan',
          2: 'online_service'
        }[index],
        goods_id: '',
        module_plate_id: ''
      };
    });
    var finalShowStyle = show_style || this.value.show_type || 1; // 兼容新老组件
    this.$set(this.value, 'config', {
      show_style: finalShowStyle,
      margin_top: margin_top,
      z_index: z_index,
      position: _objectSpread({
        flag: true,
        icon_size: 40,
        // 图标文字大小
        icon_color: finalShowStyle === 3 ? '#ffffff' : '#c20c0c',
        // 图标文字颜色
        font_size: 28,
        // 文字大小
        font_color: finalShowStyle === 3 ? '#ffffff' : '#c20c0c',
        // 文字颜色
        in_icon_size: 20,
        // 进入图标文字大小
        in_icon_color: finalShowStyle === 3 ? '#ffffff' : '#c20c0c',
        // 进入图标文字颜色
        bg_color: '#ffffff',
        // 背景颜色
        opacity: 30
      }, position),
      //定位
      // show_style === 1 START
      value: value,
      switch_account: _objectSpread({
        flag: true,
        imageurl: 'https://res.youlianfuwu.com/mini_program/shop/cs.png',
        account_sort: 1
      }, switch_account),
      //切换企业
      // show_style === 1 END

      // show_style === 2 START
      bg_color: bg_color,
      split_color: split_color,
      search: _objectSpread({
        flag: true,
        show_type: 1,
        placeholder: '搜索',
        bg_color: finalShowStyle === 3 ? '#ffffff' : '#f4f3f5',
        opacity: 100
      }, search),
      //搜索
      menus: _objectSpread({
        flag: false,
        // 功能抽屉内置默认分类数据默认即为合法 开启更多功能框可直接保存 仅抽屉内表单校验失败时置为false拦截
        valid: true,
        show_style: 1,
        imageurl: finalShowStyle === 3 ? 'https://ylfwresource.oss-cn-beijing.aliyuncs.com/gift-admin/workbench/more.png' : 'https://res.youlianfuwu.com/mini_program/more_new.png',
        value: []
      }, menus) //更多功能
      // show_style === 2 END
    });
    // 旧数据兼容：已开启更多功能框但功能抽屉无数据时补默认分类
    this.changeMenusFlag(this.value.config.menus.flag);
    this.getPicture();
  }
};